<template>
  <div class="table-page-search-wrapper">
      <a-form :layout="layout">
                       <a-row :gutter="gutter"> <a-col :md="spanMd" :sm="24">
                      <a-form-item label="应用名称">
                        <a-input placeholder="请输入应用名称" :allowClear="true" autocomplete="off" v-model="searchModel.appName"/>
                      </a-form-item>
                    </a-col><a-col :md="4" :sm="24">
                    <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                      <a-button type="primary" @click="search">查询</a-button>
                      <a-button style="margin-left: 8px" @click="clearSearch">重置</a-button>
                      <a @click="toggleAdvanced" style="margin-left: 8px"  v-if="false" v-show="showExpend">
                        {{ advanced ? '收起' : '展开' }}
                        <a-icon :type="advanced ? 'up' : 'down'"  v-if="false" v-show="showExpend"/></a>
                    </span>
                  </a-col>
              </a-row>
          </a-form>
  </div>
</template>

<script>

import { mapState } from 'vuex'
export default {
  name: 'fpsSearchForm',
  mounted () {

  },
  computed: {
    ...mapState({

    })
  },
  data () {
    return {
      layout:'inline',
      gutter:48,
      spanMd:6,
      spanSm:24,
      showExpend: true,

      searchModel: {
      },
      advanced: false//是否展开
    }
  },
  methods: {

    // 搜索框展开
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    // 点击查询按钮
    search () {
      for(var key in this.searchModel) {
        if(this.searchModel[key]===undefined || this.searchModel[key]===null || this.searchModel[key]===''){
          delete this.searchModel[key]
        }
      }
      this.$emit('setSearchCondition', this.searchModel)
    },
    // 点击复位按钮
    clearSearch () {
      this.searchModel.appName = ''

      this.$emit('clearSearch', this.searchModel)
    },
    // 获取select列表

  }
}
</script>

<style scoped lang="less">

</style>